import { I18n } from 'i18n-js';
import type { Language } from './languages';
import { toI18n } from './translation-parser';
import { translation } from './translation';

export type TranslationOptions = Record<string, unknown>;

export const i18n = new I18n(toI18n(translation));
i18n.defaultLocale = 'es';
i18n.locale = 'es';

export function setI18nLocale(locale: Language): typeof i18n {
  i18n.locale = locale;
  return i18n;
}

export function translate(scope: string, locale: Language, options?: TranslationOptions): string {
  return i18n.t(scope, {
    ...(options ?? {}),
    locale,
  }) as string;
}
